import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      if (window.location.pathname !== '/' && !window.location.pathname.includes('/auth')) {
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);

export default api;

// Auth API
export const authAPI = {
  requestMagicLink: (email) => api.post('/auth/magic-link', { email }),
  verifyMagicLink: (token) => api.get(`/auth/verify?token=${token}`),
  staffLogin: (email, password) => api.post('/auth/staff/login', { email, password }),
  getMe: () => api.get('/auth/me'),
  changePassword: (currentPassword, newPassword) => api.put('/staff/change-password', { current_password: currentPassword, new_password: newPassword }),
};

// Customer API
export const customerAPI = {
  getAll: (params) => api.get('/customers', { params }),
  getById: (id) => api.get(`/customers/${id}`),
  update: (id, data) => api.put(`/customers/${id}`, data),
  getTransactions: (id, limit = 50) => api.get(`/customers/${id}/transactions?limit=${limit}`),
  getQR: (id) => api.get(`/customers/${id}/qr`),
};

// Points API
export const pointsAPI = {
  add: (data) => api.post('/points/add', data),
  redeem: (data) => api.post('/points/redeem', data),
};

// QR API
export const qrAPI = {
  verify: (data) => api.post('/qr/verify', data),
  getRewardQR: (customerId, rewardId) => api.get(`/qr/reward/${customerId}/${rewardId}`),
};

// Services API
export const servicesAPI = {
  getAll: (params) => api.get('/services', { params }),
  getAllAdmin: () => api.get('/services/all'),
  create: (data) => api.post('/services', data),
  update: (id, data) => api.put(`/services/${id}`, data),
  delete: (id) => api.delete(`/services/${id}`),
};

// Rewards API
export const rewardsAPI = {
  getAll: () => api.get('/rewards'),
  getAllAdmin: () => api.get('/rewards/all'),
  create: (data) => api.post('/rewards', data),
  update: (id, data) => api.put(`/rewards/${id}`, data),
  delete: (id) => api.delete(`/rewards/${id}`),
};

// Promotions API
export const promotionsAPI = {
  getActive: () => api.get('/promotions'),
  getAll: () => api.get('/promotions/all'),
  create: (data) => api.post('/promotions', data),
  update: (id, data) => api.put(`/promotions/${id}`, data),
  delete: (id) => api.delete(`/promotions/${id}`),
};

// Staff API
export const staffAPI = {
  getAll: () => api.get('/staff'),
  create: (data) => api.post('/staff', data),
  deactivate: (id) => api.put(`/staff/${id}/deactivate`),
  activate: (id) => api.put(`/staff/${id}/activate`),
};

// Notifications API
export const notificationsAPI = {
  getAll: () => api.get('/notifications'),
  create: (data) => api.post('/notifications', data),
};

// Analytics API
export const analyticsAPI = {
  getDashboard: () => api.get('/analytics/dashboard'),
  getServices: () => api.get('/analytics/services'),
};

// Export API
export const exportAPI = {
  customers: () => api.get('/export/customers'),
};

// Seed API
export const seedAPI = {
  seed: () => api.post('/seed'),
};
